<app-record-slider #slider [items]="swiperItems" [swiperConfigType]="swiperType" [showActions]="true" (indexClicked)="openResourceInfo($event)">
  <ng-template appSliderTitle>
    <span class="title">{{ 'user.careerplans.knowledge' | translate }}</span>
  </ng-template>
  <ng-template appSliderActions>
    <div class="actions-wrapper">
      <app-slider-view-more-button (click)="goToResults()"></app-slider-view-more-button>
    </div>
  </ng-template>
</app-record-slider>
